// extracted by mini-css-extract-plugin
module.exports = {"custom":"buttonDanger_custom__dZS7s"};